'use strict';
(function () {
  angular.module('pentaApp').factory('points.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/points');
  }
})();